import { createApiRequest } from "@/lib/api/createApiService";
import { RESPONSE_SURVEY_ENDPOINTS } from "./response-survey.endpoints";
import apiClient from "@/lib/api/client";
const downloadBlob = ({ data, filename }) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const responseSurveyService = {
  submitResponse: async (payload, options = {}) => {
    return createApiRequest({
      url: RESPONSE_SURVEY_ENDPOINTS.SUBMIT_RESPONSE,
      method: "POST",
      body: payload,
      ...options,
    });
  },
  listSurveyResponses: async (params = {}, options = {}) => {
    return createApiRequest({
      url: RESPONSE_SURVEY_ENDPOINTS.LIST,
      method: "GET",
      body: params,
      ...options,
    });
  },
  getSurveyResponseById: async (id, params = {}, options = {}) => {
    return createApiRequest({
      url: RESPONSE_SURVEY_ENDPOINTS.GETSURVEYRESONSEBYID(id),
      method: "GET",
      body: params,
      ...options,
    });
  },

  updateSurveyResponse: async (id, payload, options = {}) => {
    return createApiRequest({
      url: RESPONSE_SURVEY_ENDPOINTS.UPDATE(id),
      method: "PUT",
      body: payload,
      ...options,
    });
  },
  uploadAttachment: async (companyId, files, options = {}) => {
    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }
    return createApiRequest({
      url: RESPONSE_SURVEY_ENDPOINTS.UPLOAD_ATTACHMENT(companyId),
      method: "POST",
      body: formData,
      isFormData: true,
      ...options,
    });
  },
  deleteAttachment: async (fileId, options = {}) => {
    return createApiRequest({
      url: RESPONSE_SURVEY_ENDPOINTS.DELETE_ATTACHMENT(fileId),
      method: "DELETE",
      ...options,
    });
  },
  downloadAttachment: async (proof) => {
    const fileId = proof?.fileId || proof?._id;
    if (!fileId) return;
    const { data } = await apiClient.get(`/files/download/${fileId}`, {
      responseType: "blob",
    });
    downloadBlob({
      data,
      filename: proof.name || proof.originalName || "download",
    });
  },
};
